// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1chq5","header":"ReportDetails_header__1LgBO","title":"ReportDetails_title__1Feno","left":"ReportDetails_left__ixnm5"};